import { useCallback, useEffect, useState } from 'react';
import MercadoPagoCheckoutModal from './MercadoPagoCheckoutModal';
import { useAuth } from '../context/AuthContext';

export default function PortalPaymentModal({ title, amount, preferencePath, body, onClose, onSuccess }) {
  const { authRequestJson } = useAuth();
  const [publicKey, setPublicKey] = useState('');
  const [configError, setConfigError] = useState('');

  useEffect(() => {
    let active = true;
    authRequestJson('/portal/me/mercadopago/config')
      .then((response) => {
        if (!active) return;
        setPublicKey(response?.data?.publicKey || '');
        if (!response?.data?.configured) setConfigError('Mercado Pago todavía no está configurado para esta cuenta.');
      })
      .catch((error) => {
        if (active) setConfigError(error.message || 'No se pudo cargar la configuración de pago.');
      });
    return () => { active = false; };
  }, [authRequestJson]);

  const getPreference = useCallback(
    () => authRequestJson(preferencePath, body ? { method: 'POST', body: JSON.stringify(body) } : { method: 'POST' }),
    [authRequestJson, body, preferencePath],
  );

  if (configError) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(event) => event.stopPropagation()}>
          <div className="modal-header"><h2>{title || 'Pago'}</h2><button type="button" className="modal-close" onClick={onClose}>×</button></div>
          <div className="modal-body"><div className="portal-alert portal-alert--error">{configError}</div></div>
          <div className="modal-footer"><button type="button" className="portal-btn portal-btn--outline" onClick={onClose}>Cerrar</button></div>
        </div>
      </div>
    );
  }

  return (
    <MercadoPagoCheckoutModal
      title={title}
      amount={amount}
      publicKey={publicKey}
      getPreference={getPreference}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
}
